module.exports = __webpack_public_path__ + "static/media/6.cedde785.png";